/** Returns a random integer in [0, max) — max is exclusive */
export const getRandomInt = (max: number): number => Math.floor(Math.random() * max);
